import React from 'react';
import '../assets/css/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
     <b> <p>&copy; SMS</p> </b>
      <nav>
        
      </nav>
    </footer>
  );
}

export default Footer;